import { useRequest } from '@/hooks/useRequest';
import {
  CreateTokenRequest,
  CreateTokenResponse,
  RequestVerificationCodeRequest,
  User
} from '@/types/auth';

export const requestVerificationCode = (
  params: RequestVerificationCodeRequest
): Promise<{ success: boolean; verificationCode: string }> => {
  const { request } = useRequest();
  return request(
    {
      url: '/api/v1/verification/challenge',
      method: 'POST',
      data: params
    },
    { needLogin: false }
  );
};

export const createToken = (params: CreateTokenRequest): Promise<CreateTokenResponse> => {
  const { request } = useRequest();

  return request(
    {
      url: '/api/v2/user/token',
      method: 'POST',
      data: params
    },
    { needLogin: false }
  );
};

export const registerUser = (params: {
  emailAddress?: string;
  phoneNumber?: string;
  password: string;
  username: string;
  verificationCode: string;
}): Promise<CreateTokenResponse> => {
  const { request } = useRequest();
  return request(
    {
      url: '/api/v1/user',
      method: 'PATCH',
      data: params
    },
    { needLogin: false }
  );
};

export const getUserInfo = (): Promise<{ user: User }> => {
  const { request } = useRequest();
  return request({ url: '/api/v1/user', method: 'GET' }, { needLogin: true });
};

export const getReferralInfo = (): Promise<{ referralCode: string }> => {
  const { request } = useRequest();
  return request(
    {
      url: '/api/v2/user/referral',
      method: 'GET'
    },
    { needLogin: true }
  );
};

export const bindReferralCode = (referralCode: string): Promise<{ success: boolean }> => {
  const { request } = useRequest();
  return request(
    {
      url: '/api/v2/user/referral',
      method: 'POST',
      data: { referralCode }
    },
    { needLogin: true }
  );
};
